<div class="modal-header">
  <h6 class="modal-title d-flex align-items-center gap-2">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Save Template</ng-container>
  </h6>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" class="row no-margin">
    <div class="offset-2 col-md-8">
      <mat-form-field2 class="mat-block">
        <input type="text" matInput required i18n-placeholder placeholder="Template Name" formControlName="name" />
        <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
          <ng-container i18n>Template Name is required</ng-container>
        </mat-error>
        <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('minlength')">
          <ng-container i18n>Template Name must be at least 2 characters long</ng-container>
        </mat-error>
        <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('maxlength')">
          <ng-container i18n>Template Name must be at most 50 characters long</ng-container>
        </mat-error>
        <mat-hint align="end">{{ form.get('name').value.length || 0 }}/50</mat-hint>
      </mat-form-field2>
    </div>

    <div class="offset-2 col-md-8">
      <mat-form-field2 class="mat-block">
        <input type="text" matInput i18n-placeholder placeholder="Description" formControlName="description" />
        <mat-error *ngIf="form.get('description').touched && form.get('description').hasError('minlength')">
          <ng-container i18n>Description must be at least 2 characters long</ng-container>
        </mat-error>
        <mat-error *ngIf="form.get('description').touched && form.get('description').hasError('maxlength')">
          <ng-container i18n>Description must be at most 100 characters long</ng-container>
        </mat-error>
        <mat-hint align="end">{{ form.get('description').value.length || 0 }}/100</mat-hint>
      </mat-form-field2>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button *ngIf="isEdit" (click)="onSaveAsNew(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Save As New</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <span *ngIf="isEdit" i18n>Update</span><span *ngIf="!isEdit" i18n>Save</span>
  </button>
</div>
